import request from "@/util/request"
import { User } from './model/user';

export const getUserInfo = (): Promise<User> => {
  return request({
      url: '/admin/user_info',
      method: 'post',
    })
}

export const userList = (user: User, page: number, page_size: number): Promise<{list:Array<User>,total:number}> => {
  return request({
      url: '/admin/auth/user_list',
      method: 'post',
      data: { ...user, page_size, page }
    })
}
export const getUserInfoById = (id:number|string): Promise<User> => {
  return request({
      url: '/admin/auth/user_info',
      method: 'post',
      data:{id}
    })
}
export const AddUser = (user:User): Promise<User> => {
  return request({
      url: '/admin/auth/user_edit',
      method: 'post',
      data:user
    })
}